import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function AboutMe() {
  return <section className="bg-pearl py-16 lg:py-32 relative" data-id="element-11">
      {/* Editorial top separator */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-[1px] bg-gold/50" data-id="element-12"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-13">
        {/* Mobile-only title above photo */}
        <motion.div className="lg:hidden text-center mb-8" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-14">
          <h2 className="text-3xl font-montserrat font-bold text-navy mb-2 text-center" data-id="element-15">
            Cine este dr.ing. Radu Pascu și cum te poate susține
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center" data-id="element-16">
          {/* Left Column - Image (40%) */}
          <motion.div className="lg:col-span-5 relative mx-8 lg:mx-0" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-17">
            {/* Gold accent square behind, offset diagonally */}
            <div className="absolute -top-4 -left-4 lg:-top-5 lg:-left-5 w-full h-full bg-gold rounded-sm" data-id="element-18"></div>

            {/* Navy corner accent bottom-right */}
            <div className="absolute -bottom-3 -right-3 w-20 h-20 border-b-[3px] border-r-[3px] border-navy rounded-br-sm z-20 hidden lg:block" data-id="element-19"></div>

            {/* Gold corner accent top-left */}
            <div className="absolute -top-8 -left-8 w-20 h-20 border-t-[3px] border-l-[3px] border-gold/60 rounded-tl-sm z-20 hidden lg:block" data-id="element-20"></div>

            {/* Dot pattern accent */}
            <div className="absolute -bottom-8 -left-4 w-28 h-28 z-0 opacity-25 hidden lg:block" style={{
            backgroundImage: 'radial-gradient(#1B2A4A 2px, transparent 2px)',
            backgroundSize: '10px 10px'
          }} data-id="element-21"></div>

            {/* Small gold bar accent right side */}
            <div className="absolute top-1/3 -right-6 w-3 h-20 bg-gold rounded-full z-20 hidden lg:block" data-id="element-22"></div>

            <img src="https://cdn.magicpatterns.com/uploads/roLsq9zFwq8B53WnykNiSb/Screenshot_2026-04-22_at_13.31.10.png" alt="dr.ing. Radu Pascu" className="relative aspect-[3/4] rounded-sm shadow-xl z-10 object-cover object-top w-full ring-1 ring-white/20" data-id="element-23" />
          </motion.div>

          {/* Right Column - Text (60%) */}
          <motion.div className="lg:col-span-7 flex flex-col items-start" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} data-id="element-24">
            <h2 className="hidden lg:block text-3xl md:text-4xl font-montserrat font-bold text-navy mb-2 text-center" data-id="element-25">
              Cine este dr.ing. Radu Pascu și cum te poate susține
            </h2>
            <p className="font-lora italic text-lg text-text-light mb-8 text-center" data-id="element-26">
              Doctor Inginer. Specialist în Nutriție Științifică. Consultant
              Certificat în Management (CMC).
            </p>

            <div className="font-inter text-text-medium leading-[1.8] space-y-6 max-w-[720px] mb-10" data-id="element-27">
              <p data-id="element-28">
                Sunt Radu Pascu și lucrez cu profesioniști care au cariere de
                succes, dar simt că și-au pierdut controlul asupra propriului
                corp: oboseală cronică, greutate fluctuantă, ceață mentală.
              </p>
              <p data-id="element-29">
                Prin Metoda C.E.L.O.S. îi ghidez să-și reconstruiască echilibrul
                biologic, pas cu pas, pe baza unor date reale despre corpul lor,
                nu pe baza unor liste copiate de pe internet.
              </p>
              <p data-id="element-30">
                Combin pregătirea mea de inginer de sisteme cu peste 8 ani de
                cercetare în nutriție, biorezonanță și suplimentare de precizie.
                Am trecut eu însumi prin această transformare:{' '}
                <strong className="text-navy font-bold" data-id="element-31">
                  am eliminat 50 de kilograme
                </strong>{' '}
                și mi-am reconstruit sănătatea de la zero.
              </p>
              <p data-id="element-32">
                Nu dau diete. Construiesc sisteme care funcționează și când nu
                ai chef, și când călătorești, și când ai o cină de business.
              </p>
            </div>

            <div className="bg-white p-8 rounded-sm border border-border-subtle shadow-sm w-full max-w-[720px] mb-8" data-id="element-33">
              <h3 className="font-montserrat font-bold text-navy text-xl mb-6 text-center md:text-left" data-id="element-34">
                Misiunea mea
              </h3>
              <ul className="space-y-4" data-id="element-35">
                {['De la diete yo-yo la greutate stabilă, bazată pe date', 'De la oboseală cronică la energie constantă toată ziua', 'De la confuzie informațională la un plan clar și simplu'].map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-36">
                    <div className="w-2 h-2 bg-gold mt-2.5 flex-shrink-0" data-id="element-37"></div>
                    <span className="font-inter text-text-dark font-medium" data-id="element-38">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            <a href="https://nutrisib.club/povestea" className="flex items-center gap-2 bg-navy text-pearl font-inter font-bold uppercase tracking-wide text-[17px] px-8 py-4 rounded-md hover:-translate-y-0.5 hover:shadow-lg transition-all duration-200 group self-center no-underline" data-id="element-39">
              Află mai multe despre mine
              <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-200" data-id="element-40" />
            </a>
          </motion.div>
        </div>
      </div>

      {/* Editorial bottom separator */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-24 h-[1px] bg-gold/50" data-id="element-41"></div>
    </section>;
}